import React from 'react';
import CustomerOrderTransactionList from './CustomerOrderTransactionList';

const SearchTransaction = () => (
    <CustomerOrderTransactionList searchByTransactionId />
);

export default SearchTransaction;
